export default "__VITE_ASSET__BM__daje__"